// src/core/utils/subscriptionAccess.js
//
// Shared helpers for the SubscriptionPackage / SubscriptionAccess system.
//
// IMPORTANT about casing: SubscriptionAccess uses owner auth with
// `ownerField: "email", identityClaim: "email"`, which means AppSync compares
// the row's `email` column against the RAW `email` claim on the Cognito token.
// So we deliberately do NOT lowercase what we store - we trim/strip spaces
// only, and the admin UI offers an autocomplete of real Cognito emails
// (via ReportingTeacher) so the stored value matches the account exactly.
// `emailKey()` is used for de-duplication / comparison in the UI only.

export function cleanEmail(email) {
  return (email || "").toString().trim().replace(/\s+/g, "");
}

export function emailKey(email) {
  return cleanEmail(email).toLowerCase();
}

export function sameEmail(a, b) {
  return !!a && !!b && emailKey(a) === emailKey(b);
}

// A package is "live" if it isn't soft-deleted, isn't switched off, and we are
// inside its start/expiry window (both optional).
export function isPackageCurrentlyActive(pkg, now = Date.now()) {
  if (!pkg || pkg._deleted) return false;
  if (pkg.active === false) return false;
  if (pkg.startsAt && new Date(pkg.startsAt).getTime() > now) return false;
  if (pkg.expiresAt && new Date(pkg.expiresAt).getTime() < now) return false;
  return true;
}

// yyyy-mm-dd (what <v-text-field type="date"> gives you) -> AWSDateTime
export function dateInputToAWSDateTime(value, endOfDay = false) {
  if (!value) return null;
  const iso = endOfDay ? `${value}T23:59:59` : `${value}T00:00:00`;
  const d = new Date(iso);
  return isNaN(d.getTime()) ? null : d.toISOString();
}

// AWSDateTime -> yyyy-mm-dd
export function awsDateTimeToDateInput(value) {
  if (!value) return null;
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d.toISOString().slice(0, 10);
}
